import { dealApi } from 'common/api/entitiesApi'
import { EntitySelector } from 'common/components/reloadable/EntitySelector'
import React from 'react'

interface Props {
  value?: number | number[]
  onChange?: (value: number) => void
  placeholder?: string
  disabled?: boolean
  style?: React.CSSProperties
  multiple?: boolean
}

export const DealSelector: React.FC<Props> = ({ value, onChange, style, disabled, placeholder, multiple }: Props) => {
  const loadEntity = (id: number) => {
    return dealApi.deal(id)
  }

  const searchEntities = (search: string, size: number, page: number) => {
    return dealApi.dealPage('name', undefined, undefined, undefined, {
      query: { size, page },
    })
  }

  return (
    <EntitySelector
      value={value}
      onChange={onChange}
      loadEntity={loadEntity}
      searchEntities={searchEntities}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      errorText="Can't load Deals"
      multiple={multiple}
    />
  )
}
